<template>
  <div>
    <el-tooltip v-if="$route.query.status != 1" class="item" effect="dark" content="保单已退保或终止，不能申请保全" placement="bottom-start">
      <div class="no-btn">申请保全</div>
    </el-tooltip>
    <el-button v-else type="primary" size="small" @click="preservation">申请保全</el-button>

    <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading="listLoading">
      <el-table-column min-width="160px;" label="创建时间" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime.substring(0, 16) }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="200px;" label="批单ID/批单号" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <p>{{ scope.row.businessNo || '-' }}</p>
          <p>{{ scope.row.billNo || '-' }}</p>          
        </template>
      </el-table-column>
      <el-table-column min-width="140px;" label="变更类型" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ typeMap[scope.row.type] }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="160px;" label="变更内容" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">加{{ scope.row.addCounts }}人</span>
          <span v-else-if="scope.row.type == 2">加{{ scope.row.addCounts }}人，减{{ scope.row.delCounts }}人</span>
          <span v-else>减{{ scope.row.delCounts }}人</span>
        </template>
      </el-table-column>
      <el-table-column min-width="160px;" label="批改生效日期" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime.substring(0, 10) }}</span>
        </template>
      </el-table-column>

      <el-table-column min-width="160px;" label="保费（元）" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ fee(scope) }}</span>
        </template>
      </el-table-column>

      <el-table-column min-width="160px;" label="服务费（元）" :show-overflow-tooltip="true" v-if="userinfo.level ==1">
        <template slot-scope="scope">
          <span>{{ commissionFee(scope) }}</span>
        </template>
      </el-table-column>
      <el-table-column property="status" min-width="160px;" label="状态" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{ statusMap[scope.row.status] }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="110px" fixed="right">
        <template slot-scope="scope">
          <el-button-group class="button-group">
            <el-button 
              type="text" 
              size="small" 
              :class="{ 'btn-grey': scope.row.status == '-99' }" 
              @click="detail(scope.row)" 
              v-if="scope.row.status == '50' || 
                scope.row.status == '-15' || 
                scope.row.status == '-15' || 
                scope.row.status == '0' || 
                scope.row.status == '20' || 
                scope.row.status == '30' || 
                scope.row.status == '40' || 
                scope.row.status == '-20'"
              >
              详情
            </el-button>

            <el-button 
              type="text" 
              size="small" 
              @click="exportBillFiles(scope.row)" 
              v-if="scope.row.billFiles && scope.row.status == '50'"
            >
              下载批单
            </el-button>

            <el-button 
              type="text" 
              size="small" 
              @click="reset(scope.row)" 
              v-if="scope.row.status == '-15' || 
                scope.row.status == '0' || 
                scope.row.status == '20'"
            >
              撤销
            </el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      listLoading: true,
      pageNum: 1,
      pageSize: 10,
      pageFlag: false,
      allData: null, // 订单列表所有数据
      tableData: [],
      typeMap: {
        1: '增保',
        2: '替保',
        3: '减保'
      },
      statusMap: {
        '-20': '批改失败',
        '-15': '核保失败',
        0: '待提交',
        20: '待支付/确认',
        30: '待实收',
        40: '待承保',
        50: '已完成',
        '-99': '已撤销'
      },
      userinfo: {}
    }
  },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
    this.getList();
  },
  methods: {
    // 列表服务费
    commissionFee(params) {
      let type = params.row.type; // 1-增  2-替 3-减
      let unit = '';
      if (type == 3) {
        unit = '-';
      }
      if (params.row.commission) {
        return unit + params.row.commission;
      } else {
        return '-'
      }
    },
    // 保费
    fee(params) {
      let type = params.row.type; // 1-增  2-替 3-减
      let unit = '';
      if (type == 3) {
        unit = '-';
      }
      return unit + params.row.fee;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    handleParams() {
      let params = {};
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      params.policyNo = this.$route.query.policyNo;

      for (var key in params) {
        if (params[key] === "") {
          delete params[key];
        }
      }
      return params;
    },
    getList() {
      this.$http({
        url: '/master/group/queryEndorsementList',
        type: 'POST',
        params: this.handleParams(),
      }).then((res) => {
        this.listLoading = false;
        this.tableData = res.data;
        this.pageFlag = false
        this.allData = res;
        if (this.allData.total != 0) {
          this.pageFlag = true
        }
      })
    },

    // 申请保全
    preservation() {
      this.$http({
        url: '/master/group/preservation',
        type: 'GET',
        params: {
          policyNo: this.$route.query.policyNo
        },
      }).then((res) => {
        window.open(res.data, '_blank');
      })
    },

    // 详情
    detail(row) {
      this.$http({
        url: "/master/group/queryEndorsementDetail",
        type: "GET",
        params: {
          id: row.id
        }
      }).then((res) => {
        window.open(res.data, "_blank");
      });
    },

    // 下载批单
    exportBillFiles(row) {
      this.$tools.daochu("/master/group/downlaodEndorsement", { billNo: row.billNo }, 'POST');
    },

    // 撤销
    reset(row) {
      this.$confirm('请确认是否要撤销？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(() => {
        this.$http({
          url: "/master/group/cancelEndorsement",
          type: "GET",
          params: {
            businessNo: row.businessNo
          }
        }).then((res) => {
          this.$message({
            message: "撤销成功",
            type: "success",
          });
          this.getList();
        });
      })
    },

  },
}
</script>

<style lang="scss" scoped>
.list-table {
  margin-top: 20px;
}

/deep/.button-group {
  display: flex;
  justify-content: space-between;
}

.btn-grey {
  color: #999 !important;
  pointer-events: none !important;
}

.no-btn {
  width: 82px;
  height: 32px;
  color: #fff;
  border: 1px solid #fabc80;
  border-radius: 2px;
  background-color: #fabc80;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: no-drop;
}
</style>